
import React, {
  useState,
  useContext,
  useMemo,
  useEffect,
  useCallback,
  useLayoutEffect,
} from "react";
// import IndustryDropdown from "../../IndustryDropdown";
import { ArrowCircleDown, ArrowCircleUp, QuestionAnswer } from "@mui/icons-material";

import { AppContext, defaultSiteName } from "../main";
import moment from "moment";
import { MyFileUploader } from "../Components/MyFileUploader";
import useLocalStorage from "use-local-storage";

import {
  getDataDB,
  saveDataDB,
  modifyDataModel,
  modifyTextAI,
  countWords,
  isDescriptionField,
  isImageField,
  handleFontAwesomeRedirect
} from "../api";


export const EditModal = (props) => {
  const { item, onSave, onClose, setLoading, loading } = props;
  const { appState } = useContext(AppContext);
  const { editSection, defaultConfig = {} } = appState;
  const [myStore, setMyStore] = useLocalStorage("name", {});
  const {
    myInfo,
    myInfo: { siteName = "banking-v1" },
  } = myStore;

  const [editedItem, setEditedItem] = useState(item || {});
  const [imageFiles, setImageFiles] = useState({});
  const [refreshing, setRefreshing] = useState(false);
  const [uploadNow, setUploadNow] = useState(false);
  const [formInputState, setFormInputState] = useState(false);

  const [aiLoading, setAILoading] = useState(false);
  const [fieldWithAI, setFieldWithAI] = useState(null);
  const [aILoadingNow, setAILoadingNow] = useState(false);

  const [stripeKey, setStripeKey] = useState({});

  useEffect(() => { //todo:dee add to other applications
    setEditedItem(item)
  }, [
    item
  ])




  // const handleInputChange = (key, value) => {
  //     setEditedItem((prev) => ({ ...prev, [key]: value }));
  // };

  const handleInputChange = (key, value) => {
    setEditedItem((prev) => ({ ...prev, [key]: value !== undefined && value !== null ? String(value) : '' }));
  };


  const handleNestedChange = (parentKey, nestedKey, value) => {
    setEditedItem((prev) => ({
      ...prev,
      [parentKey]: {
        ...prev[parentKey],
        [nestedKey]: value,
      },
    }));
  };

  const handleArrayChange = (arrayKey, index, key, value) => {
    const updatedArray = editedItem[arrayKey]?.map((item, i) =>
      i === index ? { ...item, [key]: value } : item
    );
    setEditedItem((prev) => ({ ...prev, [arrayKey]: updatedArray }));
  };

  const moveArrayItem = (arrayKey, index, direction) => {
    const newIndex = index + direction;
    if (newIndex < 0 || newIndex >= editedItem[arrayKey].length) return;

    const updatedArray = [...editedItem[arrayKey]];
    [updatedArray[index], updatedArray[newIndex]] = [
      updatedArray[newIndex],
      updatedArray[index],
    ];

    setEditedItem((prev) => ({ ...prev, [arrayKey]: updatedArray }));
  };


  const addArrayItem = (arrayKey) => {
    setEditedItem((prev) => {
      const existingArray = prev[arrayKey] || [];

      // Try to get a sample template from existing items or the default config
      let templateSource = existingArray.find(
        (item) => typeof item === "object"
      );

      if (!templateSource) {
        templateSource = defaultConfig?.[editSection]?.[arrayKey]?.[0] || {};
      }

      const generateEmptyValue = (value) => {
        if (typeof value === "number") return 0;
        if (typeof value === "boolean") return false;
        if (Array.isArray(value)) return [];
        if (typeof value === "object" && value !== null) {
          return Object.fromEntries(
            Object.entries(value).map(([k, v]) => [k, generateEmptyValue(v)])
          );
        }
        return "";
      };

      const newItem = Object.fromEntries(
        Object.entries(templateSource).map(([k, v]) => [
          k,
          k === "id" ? existingArray.length + 1 : generateEmptyValue(v),
        ])
      );

      return {
        ...prev,
        [arrayKey]: [...existingArray, newItem],
      };
    });
  };
  const [removedItemIds, setRemovedItemIds] = useState({});

  // const removeArrayItem = (arrayKey, index) => {
  //     setEditedItem((prev) => ({
  //         ...prev,
  //         [arrayKey]: prev[arrayKey].filter((_, i) => i !== index),
  //     }));
  // };
  const removeArrayItem = (arrayKey, index) => {
    setEditedItem((prev) => ({
      ...prev,
      [arrayKey]: prev[arrayKey].filter((_, i) => i !== index),
    }));

    // Update the defaultConfig in-place to reflect the deletion
    if (defaultConfig?.[editSection]?.[arrayKey]) {
      defaultConfig[editSection][arrayKey] = defaultConfig[editSection][arrayKey].filter((_, i) => i !== index);
    }
  };


  const isDefault = useMemo(() => {
    return (
      JSON.stringify(defaultConfig[editSection]) == JSON.stringify(editedItem)
    );
  }, [appState, editSection, editedItem]);

  // const cleanedItem = useCallback((editedItem) => {
  //     return Object.fromEntries(
  //         Object.entries(editedItem).map(([k, v]) => {
  //             if (Array.isArray(v)) {
  //                 return [
  //                     k,
  //                     v.filter((entry) => Object.values(entry).some((val) => val !== "")),
  //                 ];
  //             }
  //             return [k, v];
  //         })
  //     );
  // }, []);
  // const [removedItemIds, setRemovedItemIds] = useState({});

  const cleanedItem = useCallback((editedItem) => {
    return Object.fromEntries(
      Object.entries(editedItem).map(([k, v]) => {
        if (Array.isArray(v)) {
          const removedIds = removedItemIds[k] || [];

          const filtered = v.filter(entry => {
            const isRemoved = removedIds.includes(entry.id);
            if (isRemoved) return false;

            return Object.values(entry).some(val => {
              if (typeof val === 'string') return val.trim() !== '';
              if (Array.isArray(val)) return val.length > 0;
              if (typeof val === 'object' && val !== null) return Object.keys(val).length > 0;
              return val !== null && val !== undefined;
            });
          });

          return [k, filtered];
        }
        return [k, v];
      })
    );
  }, [removedItemIds]);


  useEffect(() => { }, [fieldWithAI]);

  return (
    <div
      style={{
        width: "100%",
        zIndex: 5,
        height: "auto",
        display: "flex",
        position: "relative",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "white",
        padding: 50,
      }}
    >
      {aILoadingNow && (
        <div
          style={{
            position: "absolute",
            zIndex: 99999,
            display: "flex",
            backgroundColor: "rgba(0,0,0,0.5)",
            height: "100%",
            width: "100%",
            fontSize: 40,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Loading....
        </div>
      )}
      <div
        className="modal-content"
        style={{
          width: 500,
          display: "flex",
          flexDirection: "column",
          gap: 20,
          padding: 20,
        }}
      >
        <h2>{`Edit ${editSection}`}</h2>

        {editedItem?.aiAssist && (
          <div
            style={{
              padding: 20,
            }}
          >
            {" "}
            <AiPromptBox
              handleText={(text) => {
                // alert(text)
                setAILoading(true);
                modifyDataModel({
                  industry: text,
                  dataModel: defaultConfig?.[editSection],
                }).then((res) => {
                  // console.log('xxxxxxxx', res)
                  setEditedItem(res);
                  setAILoading(false);
                });
              }}
              aiLoading={aiLoading}
            />
          </div>
        )}

        {!isDefault && (
          <button
            className="btn-main"
            onClick={() => setEditedItem(defaultConfig[editSection])}
            style={{
              marginLeft: 30,
              marginRight: 30,
            }}
          >
            Reset to Default
          </button>
        )}

        {Object.entries(editedItem)?.map(([key, value], index) => {
          if (
            // key === "menu" &&
            typeof value === "boolean"
          ) {
            return (
              <div
                key={key}
                style={{ display: "flex", alignItems: "center", gap: 10 }}
              >
                <label style={{ minWidth: "100px" }}>{key}</label>
                <input
                  type="checkbox"
                  checked={value}
                  onChange={(e) => handleInputChange(key, e.target.checked)}
                />
              </div>
            );
          }
          if (Array.isArray(value)) {
            return (
              <div
                key={key}
                style={{ display: "flex", flexDirection: "column", gap: 10 }}
              >
                <label>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                {value.map((entry, index) => (
                  <div
                    key={entry.id ?? index}
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 5,
                      borderBottom: "1px solid #ddd",
                      paddingBottom: 10,
                    }}
                  >
                    {Object.entries(entry)?.map(([field, fieldValue]) => {
                      const isDate = field.toLowerCase() == "date" || field == "endDate";
                      if (field !== "id") {
                        if (
                          Array.isArray(fieldValue) &&
                          fieldValue.every((v) => typeof v === "object")
                        ) {
                          return (
                            <div
                              key={field}
                              style={{
                                marginLeft: 20,
                                borderLeft: "2px solid #eee",
                                paddingLeft: 10,
                              }}
                            >
                              <label style={{ fontWeight: "bold" }}>
                                {field.charAt(0).toUpperCase() + field.slice(1)}
                              </label>
                              {fieldValue.map((subItem, subIndex) => (
                                <div
                                  key={subIndex}
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 5,
                                    marginBottom: 5,
                                  }}
                                >
                                  {Object.entries(subItem).map(
                                    ([subKey, subValue]) => (
                                      <div
                                        key={subKey}
                                        style={{
                                          display: "flex",
                                          alignItems: "center",
                                          gap: 10,
                                        }}
                                      >
                                        <label style={{ minWidth: "60px" }}>
                                          {subKey}
                                        </label>
                                        <input
                                          type={
                                            subKey == "Day" ? "datetime-local" : "text"
                                          }
                                          value={subValue}
                                          onChange={(e) => {
                                            const updatedArray = [
                                              ...editedItem[key],
                                            ];
                                            updatedArray[index][field][
                                              subIndex
                                            ][subKey] = e.target.value;
                                            setEditedItem((prev) => ({
                                              ...prev,
                                              [key]: updatedArray,
                                            }));
                                          }}
                                          style={{ flex: 1 }}
                                        />
                                      </div>
                                    )
                                  )}
                                  <button
                                    onClick={() => {
                                      const updatedArray = [...editedItem[key]];
                                      updatedArray[index][field] = updatedArray[
                                        index
                                      ][field].filter((_, i) => i !== subIndex);
                                      setEditedItem((prev) => ({
                                        ...prev,
                                        [key]: updatedArray,
                                      }));
                                    }}
                                    style={{
                                      color: "red",
                                      border: "none",
                                      background: "none",
                                      alignSelf: "flex-start",
                                    }}
                                  >
                                    Remove
                                  </button>
                                </div>
                              ))}
                              <button
                                onClick={() => {
                                  const updatedArray = [...editedItem[key]];
                                  updatedArray[index][field] = [
                                    ...updatedArray[index][field],
                                    { name: "" },
                                  ];
                                  setEditedItem((prev) => ({
                                    ...prev,
                                    [key]: updatedArray,
                                  }));
                                }}
                              >
                                Add Item
                              </button>
                            </div>
                          );
                        }
                        return (
                          <div
                            key={field}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              gap: 5,
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: 10,
                              }}
                            >
                              <label style={{ minWidth: "80px" }}>
                                {field.charAt(0).toUpperCase() + field.slice(1)}
                              </label>
                              <input
                                // type="text"
                                type={isDate ? "datetime-local" : "text"}
                                value={fieldValue}
                                onChange={(e) =>
                                  handleArrayChange(
                                    key,
                                    index,
                                    field,
                                    e.target.value
                                  )
                                }
                                style={{ flex: 1 }}
                              />
                              {!isImageField(`${field}`) &&
                                typeof fieldValue === 'string'
                                && !fieldValue.includes(".com")
                                && isDescriptionField(`${field}`)
                                && (
                                  <button
                                    onClick={() => {
                                      modifyTextAI({
                                        text: fieldValue,
                                        length: fieldValue ? countWords(fieldValue) : 10,
                                      }).then((res) => {
                                        // alert(JSON.stringify(res))
                                        if (res) {
                                          handleArrayChange(
                                            key,
                                            index,
                                            field,
                                            res
                                          )
                                        }
                                      });
                                    }}
                                    style={{
                                      // background: "none",
                                      border: "none",
                                      cursor: "pointer",
                                      backgroundColor: "blue",
                                      color: "white",
                                    }}
                                    title="Generate with AI"
                                  >
                                    AI (Task)
                                  </button>
                                )}
                              {field == 'icon' && (
                                <QuestionAnswer
                                  onClick={() => {
                                    handleFontAwesomeRedirect()
                                  }}
                                />
                              )}
                            </div>
                            {isImageField(field) && (
                              <MyMedia
                                fieldValue={fieldValue}
                                entry={entry}
                                handleNewFile={() => { }}
                                defaultItem={defaultConfig[editSection]}
                              />
                            )}
                          </div>
                        );
                      }
                      return null;
                    })}

                    <div
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <label>ID</label>
                      <input
                        type="number"
                        value={entry.id}
                        readOnly
                        style={{ width: 60, textAlign: "center" }}
                      />
                      <button
                        onClick={() => moveArrayItem(key, index, -1)}
                        disabled={index === 0}
                      >
                        &uarr;
                      </button>
                      <button
                        onClick={() => moveArrayItem(key, index, 1)}
                        disabled={index === value.length - 1}
                      >
                        &darr;
                      </button>
                    </div>

                    <button
                      onClick={() => removeArrayItem(key, index)}
                      style={{
                        backgroundColor: "red",
                        color: "white",
                        border: "none",
                        padding: "5px 10px",
                      }}
                    >
                      Remove
                    </button>
                  </div>
                ))}
                <button
                  onClick={() =>
                    addArrayItem(key, {
                      title: "",
                      header: "",
                      price: "",
                      image: "",
                      description: "",
                    })
                  }
                  className="btn-main"
                >
                  Add {key.slice(0, -1)}
                </button>
              </div>
            );
          }

          if (typeof value === "object" && value !== null) {
            return (
              <div
                key={key}
                style={{ display: "flex", flexDirection: "column", gap: 10 }}
              >
                <label>{key.charAt(0).toUpperCase() + key.slice(1)}</label>
                {Object.entries(value)?.map(([nestedKey, nestedValue]) => (
                  <div
                    key={nestedKey}
                    style={{ display: "flex", flexDirection: "column", gap: 5 }}
                  >
                    <div
                      style={{ display: "flex", alignItems: "center", gap: 10 }}
                    >
                      <label style={{ minWidth: "80px" }}>{nestedKey}</label>
                      <div
                        style={{
                          display: "flex",
                          alignItems: "center",
                          flex: 1,
                          gap: 5,
                        }}
                      >

                        <textarea
                          value={nestedValue}
                          onChange={(e) =>
                            handleNestedChange(key, nestedKey, e.target.value)
                          }
                          style={{
                            flex: 1,
                            height: "1.5em", // height of one line (adjust as needed)
                            lineHeight: "1.5em", // ensure vertical centering
                            overflowY: "auto",
                            resize: "vertical",
                          }}
                        />
                        {!isImageField(`${key}.${nestedKey}`) &&
                          !nestedValue?.includes(".com")
                          && isDescriptionField(`${key}.${nestedKey}`)
                          && (
                            <button
                              onClick={() => {
                                modifyTextAI({
                                  text: nestedValue,
                                  length: value ? countWords(value) + 20 : 100,
                                }).then((res) => {
                                  // alert(JSON.stringify(res))
                                  if (res)
                                    handleNestedChange(key, nestedKey, res);
                                });
                              }}
                              style={{
                                // background: "none",
                                border: "none",
                                cursor: "pointer",
                                backgroundColor: "blue",
                                color: "white",
                              }}
                              title="Generate with AI"
                            >
                              AI (Task)
                            </button>
                          )}
                        {`${key}.${nestedKey}` == 'icon' && (
                          <QuestionAnswer
                            onClick={() => {
                              handleFontAwesomeRedirect()
                            }}
                          />
                        )}
                      </div>
                    </div>
                    {isImageField(nestedValue) && (
                      <MyMedia
                        fieldValue={nestedValue}
                        entry={value}
                        handleNewFile={() => { }}
                        defaultItem={defaultConfig[editSection]}
                      />
                    )}
                  </div>
                ))}
              </div>
            );
          }

          return (
            <div
              key={key}
              style={{ display: "flex", flexDirection: "column", gap: 5 }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <label style={{ minWidth: "100px" }}>
                  {key.charAt(0).toUpperCase() + key.slice(1)}
                </label>
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    flex: 1,
                    gap: 5,
                  }}
                >
                  <textarea
                    value={value || ''}
                    onChange={(e) => handleInputChange(key, e.target.value)}
                    style={{
                      flex: 1,
                      height:
                        value && countWords(String(value)) > 5 ? '4.5em' : '1.5em', // convert value to string here
                      lineHeight: '1.5em',
                      overflowY: 'auto',
                      resize: 'vertical',
                    }}
                  />

                  {!isImageField(key) &&
                    !value?.includes(".com") && (
                      <button
                        onClick={() => {
                          setAILoadingNow(true);
                          modifyTextAI({
                            text: value,
                            length: value ? countWords(value) + 20 : 100,
                          }).then((res) => {
                            // alert(JSON.stringify(res))
                            if (res) {
                              handleInputChange(key, res);
                            }
                            setAILoadingNow(false);
                          });
                        }}
                        style={{
                          // background: "none",
                          border: "none",
                          cursor: "pointer",
                          backgroundColor: "blue",
                          borderRadius: 100,
                          color: "white",
                        }}
                        title="Generate with AI"
                      >
                        AI (Task)
                      </button>
                    )}
                  {key == 'icon' && (
                    <QuestionAnswer
                      onClick={() => {
                        handleFontAwesomeRedirect()
                      }}
                    />
                  )}
                </div>
              </div>
              {isImageField(key) && (
                <MyMedia
                  fieldValue={value}
                  entry={editedItem}
                  handleNewFile={() => { }}
                  defaultItem={defaultConfig[editSection]}
                />
              )}
            </div>
          );
        })}

        {(editSection == "pricings" || editSection == "pricelists") &&
          myInfo?.token && (
            <div>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  flex: 1,
                  gap: 5,
                  flexDirection: "column",
                  width: "100%",
                }}
              >
                <textarea
                  // type="text"
                  // type="password"
                  value={stripeKey["key"] || ""}
                  onChange={(e) => {
                    setStripeKey({
                      ...stripeKey,
                      key: e.target.value,
                    });
                  }}
                  style={{
                    flex: 1,
                    height:
                      stripeKey["key"] && countWords(stripeKey["key"]) > 5
                        ? "4.5em"
                        : "1.5em", // height of one line (adjust as needed)
                    lineHeight: "1.5em", // ensure vertical centering
                    overflowY: "auto",
                    resize: "vertical",
                    width: "100%",
                  }}
                />

              </div>
              <div
                style={{
                  display: "flex",
                  alignItems: "flex-start",
                  flex: 1,
                  gap: 5,
                  flexDirection: "column",
                  width: "100%",
                }}
              >

                <textarea
                  // type="password"
                  value={stripeKey["productId"] || ""}
                  onChange={(e) => {
                    setStripeKey({
                      ...stripeKey,
                      productId: e.target.value,
                    });
                  }}
                  style={{
                    flex: 1,
                    height:
                      stripeKey["productId"] &&
                        countWords(stripeKey["productId"]) > 5
                        ? "4.5em"
                        : "1.5em", // height of one line (adjust as needed)
                    lineHeight: "1.5em", // ensure vertical centering
                    overflowY: "auto",
                    resize: "vertical",
                    width: "100%",
                  }}
                />
              </div>
            </div>
          )}
        <div style={{
          position: "fixed",
          top: 20,
          left: "50%",
          transform: "translateX(-50%)",
          display: "flex",
          gap: "10px",
          zIndex: 10,
          backgroundColor: "#fff", // optional: white background
          padding: "10px 20px",     // optional: spacing around buttons
          borderTop: "1px solid #ddd", // optional: top border
          boxShadow: "0 -2px 5px rgba(0,0,0,0.1)", // optional: subtle shadow
        }}>
          <button
            disabled={loading}
            style={
              loading
                ? {
                  backgroundColor: "red",
                }
                : {}
            }
            onClick={async () => {
              // if (stripeKey?.productId && stripeKey?.key) {
              saveDataDB({
                query: {
                  date: moment(),
                  handle: myInfo?.handle,
                  siteName: siteName,
                  config: cleanedItem(editedItem),
                },
                keys: ["date", "siteName"],
                resource: "vare_education_versions",
              }).then((info) => {
                setLoading(true);
                setUploadNow(true);
                onSave(cleanedItem(editedItem));
              });
              return;
            }

              // setLoading(true);
              // setUploadNow(true);
              // onSave(cleanedItem(editedItem));
            }
            className="btn-main"
          >
            {loading ? "Loading..." : "Save"}
          </button>
          <button disabled={loading} onClick={onClose} className="btn-main">
            Cancel
          </button>
        </div>
      </div>
    </div >
  );
};


export default EditModal;

const MyMedia = ({ fieldValue, entry, handleNewFile, defaultItem = {} }) => {
  const [formInput, setFormInput] = useState({ picture: fieldValue });
  const [refreshing, setRefreshing] = useState(false);
  const [uploadNow, setUploadNow] = useState(false);
  const [allowAdd, setAllowAdd] = useState(false);
  const [selectedImage, setSelectedImage] = useState("");

  const imgType = ["image", "img", "src", "thumb", "full", "logo", "photo"];

  const props = {};
  useEffect(() => {
    if (formInput?.picture) {
      let key = "";
      imgType?.map((res) => {
        if (entry && typeof entry == "object" && Object.keys(entry)?.includes(res)) {
          key = res;
        }
      });
      if (key) {
        // alert(key + '-' + formInput?.picture)

        entry[key] = formInput.picture;
        // console.log('ssssssssxx5', entry)
        // handleNewFile(entry);
      }
    }
    setAllowAdd(
      selectedImage && selectedImage != formInput?.picture ? true : false
    );
  }, [formInput?.picture, selectedImage, entry]);

  // console.log('defaultItemxx', entry, defaultItem)
  return (
    <>
      <MyFileUploader
        {...props}
        defaultItem={entry?.["image"]}
        handleCancel={() => {
          setSelectedImage("");
          setFormInput({
            ...formInput,
            picture: entry?.image,
          });
        }}
        selectedImage={selectedImage}
        setSelectedImage={setSelectedImage}
        imageKey={"picture"}
        aiSearchBy={"industry"}
        resource={"gaming_site_media"}
        refreshing={refreshing}
        setRefreshing={setRefreshing}
        setFormInput={setFormInput}
        formInput={formInput}
        uploadNow={uploadNow}
        allowAdd={allowAdd}
        handleSaveImage={() => {
          setUploadNow(true);
        }}
      />
    </>
  );
};

const AiPromptBox = ({ handleText, aiLoading }) => {
  const [inputAIText, setInputAIText] = useState("");

  const onGenerate = () => {
    if (inputAIText.trim()) {
      handleText(inputAIText);
      // setInputText(''); // Optionally clear the textarea after submission
    }
  };

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
      <textarea
        value={inputAIText}
        onChange={(e) => setInputAIText(e.target.value)}
        placeholder="Use AI assistance to generate contents, type in what you want"
        rows={4}
        style={{ width: "100%", padding: "10px", fontSize: "14px" }}
      />
      <button onClick={onGenerate} className="btn-main">
        {aiLoading ? "Loading..." : "Generate"}
      </button>

      <button
        onClick={() => {
          setInputAIText("");
        }}
        className="btn-main"
      >
        Clear AI Assist
      </button>
    </div>
  );
};